/**
 * CExportModal - 导出进度弹窗
 * @author chensi
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Progress, message } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { CItemEditor } from '@components/plugins/itemEditor/CItemEditor';
import moment from 'moment';
import './cExportModal.scss';

export class CExportModal extends React.Component {
    static propTypes = {
        // 请求方法
        onSaveExportRequest: PropTypes.func,
        // 导出结果方法
        onGetExportResult: PropTypes.func,
        // 弹窗标题
        title: PropTypes.string,
        // 按钮名字
        btnName: PropTypes.string,
        // 按钮的颜色类名,需要在父组件定义好类名的样式  默认btn-info 颜色值 #00b2c2
        btnClassName: PropTypes.string,
        // 占位元素尺寸按钮大小
        size: PropTypes.string,
        // 定义底部按钮名字,数组第一个内容传空字符串为隐藏按钮
        footerBtn: PropTypes.array,
        // 定义导出进行和完成内容
        exportContent: PropTypes.array,
        // 定义操作文字和关闭文字
        operationTextConfig: PropTypes.object,
        // 警告状态
        warning: PropTypes.bool,
        // 警告状态下的提示信息
        warningMessage: PropTypes.string,
        // 点击关闭按钮之后的回调-用于刷新页面
        onRefreshDataResource: PropTypes.func,
        // 打开前进行条件判断，参数是false为不打开弹窗，默认打开
        onBeforeOpenEditor: PropTypes.func,
        // 导出界面内容
        renderExportContent: PropTypes.func,
    };

    static defaultProps = {
        title: '系统提示',
        btnName: '全部导出',
        footerBtn: ['下载文件', '关闭'],
        exportContent: ['正在进行导出，请稍候...', '导出已完成！'],
        btnClassName: 'btn-info',
        operationTextConfig: {
            start: '开始导出',
            close: '关闭',
            type: 'primary',
        },
        onRefreshDataResource: () => null,
        onBeforeOpenEditor: callback => callback(true),
    };

    constructor(props) {
        super(props);
        this.state = {
            // 导出完成开关
            exportFinishFlag: false,
            // 导出进度
            loadPercent: 0,
            // 无按钮时后端导出回调函数
            closeLoadingCallback: () => null,
            // 开始导出
            startExportFlag: false,
        };
        this.$refs = {
            editor: null,
        };
        this._data = {
            // 下载的文件地址
            downloadUrl: '',
        };
    }

    componentDidMount() {}

    componentWillUnmount() {}

    _handleSaveExportRequest() {
        if (!this.state.startExportFlag) {
            return;
        }
        this.setState({
            loadPercent: 0,
            exportFinishFlag: false,
        });
        // 调用父组件导出请求
        this.props.onSaveExportRequest(res => {
            if (!res) {
                this._handleCloseExportEditor();
                return;
            }
            const poll = () => {
                // 时间间隔，毫秒
                let interval = 2000;
                // 请求前的毫秒数
                let beforeRequestTime = moment(Date.now()).valueOf();
                this.props.onGetExportResult(res, result => {
                    // 响应时间
                    let responseTime = moment(Date.now()).valueOf();
                    if (!result) {
                        this._handleCloseExportEditor();
                        return;
                    }
                    // 等等中
                    if (result.resultCode === 2001) {
                        this.setState({
                            loadPercent: result.progress,
                        });
                        // 设置下一次轮询,响应时间减去请求时间大于间隔，立即轮询
                        if (responseTime - beforeRequestTime >= interval) {
                            setTimeout(() => poll(), 0);
                        } else if (responseTime - beforeRequestTime < interval) {
                            setTimeout(() => poll(), interval);
                        }
                    }
                    // 成功
                    else if (result.resultCode === 2000) {
                        let isParseJson = this._isParseAbleJson(result.result);
                        if (!isParseJson) {
                            message.error('操作失败！' + result.result);
                            this._handleCloseExportEditor();
                            return;
                        }
                        this.setState({
                            loadPercent: 100,
                            exportFinishFlag: true,
                        });
                        this._data.downloadUrl = (
                            JSON.parse(result.result) || {}
                        ).downloadUrl;
                    }
                    // 失败
                    else if (result.resultCode === 5000) {
                        message.error('操作失败！' + result.result);
                        this._handleCloseExportEditor();
                    }
                });
            };
            poll();
        });
    }

    _renderContent() {
        return (
            <div>
                <div
                    className="export-progress"
                    style={{ display: this.state.startExportFlag ? '' : 'none' }}
                >
                    <div className="icon">
                        {this.state.exportFinishFlag ? (
                            <CheckOutlined />
                        ) : (
                            <img src="/static/assets/images/loading-200.gif" alt="" />
                        )}
                    </div>
                    <div className="progress">
                        <Progress percent={this.state.loadPercent} />
                    </div>
                    <div className="title">
                        {this.state.exportFinishFlag
                            ? this.props.exportContent[1]
                            : this.props.exportContent[0]}
                    </div>
                </div>
                <div
                    style={{
                        display: this.state.startExportFlag ? 'none' : '',
                    }}
                >
                    {this.props.renderExportContent
                        ? this.props.renderExportContent()
                        : ''}
                    <div className="before-start">
                        <Button
                            onClick={() => this._startExport()}
                            type={this.props.operationTextConfig.type}
                            className="before-start-btn"
                        >
                            {this.props.operationTextConfig.start}
                        </Button>
                        <Button
                            onClick={() => {
                                this._handleCloseExportEditor();
                            }}
                            className="before-start-btn"
                        >
                            {this.props.operationTextConfig.close}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    _renderFooterBtn() {
        return (
            <div
                className="modal-footer-close"
                style={{ display: this.state.startExportFlag ? '' : 'none' }}
            >
                <Button
                    onClick={() => this._handleDownloadExportResult()}
                    disabled={!this.state.exportFinishFlag}
                    className="modal-footer-btn"
                    type="primary"
                    style={{ display: this.props.footerBtn[0] ? '' : 'none' }}
                >
                    {this.props.footerBtn[0]}
                </Button>
                <Button
                    onClick={() => {
                        this._handleCloseExportEditor();
                    }}
                    disabled={!this.state.exportFinishFlag}
                    className="modal-footer-btn"
                >
                    {this.props.footerBtn[1]}
                </Button>
            </div>
        );
    }

    _startExport() {
        this.setState(
            {
                startExportFlag: true,
            },
            () => {
                this.$open(this.state.closeLoadingCallback);
            },
        );
    }

    // 关闭按钮
    _handleCloseExportEditor() {
        this.state.closeLoadingCallback && this.state.closeLoadingCallback();
        this.$refs.editor.$close();
        this.props.onRefreshDataResource();
        setTimeout(() => {
            this.setState({
                loadPercent: 0,
                exportFinishFlag: false,
                startExportFlag: false,
            });
        }, 200);
    }

    // 下载文件按钮
    _handleDownloadExportResult() {
        window.open(this._data.downloadUrl);
    }

    // 无按钮调用打开导出方法
    $open(closeLoadingCallback) {
        this.$refs.editor.$open();
        this.setState({
            closeLoadingCallback,
        });
    }

    // 是否可以转成json
    _isParseAbleJson(str) {
        try {
            JSON.parse(str);
            return true;
        } catch (error) {
            return false;
        }
    }

    render() {
        return (
            <>
                <CItemEditor
                    title={this.props.title}
                    content={
                        <>
                            {this._renderContent()}
                            {this._renderFooterBtn()}
                        </>
                    }
                    placeholderType="primary"
                    size={this.props.size}
                    className={[
                        this.props.btnClassName,
                        this.props.btnName ? '' : 'not-show',
                    ].join(' ')}
                    closable={false}
                    warning={this.props.warning}
                    warningMessage={this.props.warningMessage}
                    ref={elm => (this.$refs.editor = elm)}
                    onOpenChange={evt => evt && this._handleSaveExportRequest()}
                    onBeforeOpen={evt => this.props.onBeforeOpenEditor(evt)}
                >
                    {this.props.btnName}
                </CItemEditor>
            </>
        );
    }
}
